import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowCombine = () => {
  return (
    <g>
      <path d="M2.5 1a2.5 2.5 0 0 1 1.916 4.106L4.336 5c1.16 1.572 2.242 2.195 3.93 2.247l.202.002H10V5.5a.75.75 0 0 1 1.02-.7l.094.044 4.5 2.5a.75.75 0 0 1 0 1.312l-4.5 2.5A.75.75 0 0 1 10 10.5V8.75H8.468l-.202.003c-1.65.05-2.72.646-3.85 2.14a2.5 2.5 0 1 1-1.266-.808C3.85 9.143 4.56 8.46 5.361 8 4.56 7.54 3.85 6.857 3.15 5.916A2.5 2.5 0 1 1 2.5 1zm0 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9-4.726v2.451L13.705 8 11.5 6.774zM2.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
    </g>
  );
};

export default withIcon(IconArrowCombine);
